import { http, httpFile } from './http_service';

//Get all
export function all(){
    return http().get('/faqs');
}
//Get all active
export function allActive(){
    return http().get('/faqs/active');
}
//Get Single
export function single(id){
    return http().get(`/faqs/${id}`);
}
//Add one
export function add(data){
    return http().post('/faqs', data)
}
//Update
export function update(id, data){
    return http().put(`/faqs/${id}`, data)
}
//Delete one
export function deleteSingle(id){
    return http().delete(`/faqs/${id}`);
}